const SERVER_URL =
  process.env.REACT_APP_FINANCIAL_PROMOTIONS_API_URL ||
  "https://financialpromotionsrifa.onrender.com" ||
  process.env.REACT_APP_SERVER_URL ||
  "http://localhost:5001";

const getApiUrl = (path) => {
  const cleanServerUrl = SERVER_URL.replace(/\/$/, "");
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  return `${cleanServerUrl}${cleanPath}`;
};

const parseResponse = async (res) => {
  const data = await res.json().catch(() => ({}));

  if (!res.ok || data.success === false) {
    throw new Error(data.message || "Request failed.");
  }

  return data;
};

export const getFinancialPromotionAdvisers = async () => {
  const res = await fetch(getApiUrl("/api/financial-promotions/advisers"), {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  const data = await parseResponse(res);

  return data.advisers || [];
};

export const generateFinancialPromotion = async (payload = {}) => {
  const body = {
    promotionId: payload.promotionId || null,

    adviserEmail: payload.adviserEmail || "",

    contentType: payload.contentType || "",
    contentTypes: Array.isArray(payload.contentTypes)
      ? payload.contentTypes
      : [],

    platform: payload.platform || "",
    platforms: Array.isArray(payload.platforms) ? payload.platforms : [],

    audience: payload.audience || "",
    objective: payload.objective || "",
    tone: payload.tone || "",
    notes: payload.notes || "",

    mode: payload.mode || "create",

    riskWarnings: Array.isArray(payload.riskWarnings)
      ? payload.riskWarnings
      : [],

    conversationContext: Array.isArray(payload.conversationContext)
      ? payload.conversationContext
      : [],
  };

  console.log("[Financial Promotions] Generate request body:", {
    promotionId: body.promotionId,
    mode: body.mode,
    adviserEmail: body.adviserEmail,
    contentType: body.contentType,
    platform: body.platform,
  });

  const res = await fetch(getApiUrl("/api/financial-promotions/generate"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  });

  const data = await parseResponse(res);

  console.log("[Financial Promotions] Generate response:", {
    promotionId: data.promotionId,
    responseId: data.responseId,
    status: data.status,
  });

  return data;
};

export const getFinancialPromotionResponses = async () => {
  const res = await fetch(getApiUrl("/api/financial-promotions/responses"), {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  const data = await parseResponse(res);

  return data.responses || [];
};

export const getFinancialPromotionRiskWarnings = async () => {
  const res = await fetch(
    getApiUrl("/api/financial-promotions/risk-warnings"),
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    },
  );

  const data = await parseResponse(res);

  return data.riskWarnings || [];
};
